/* @flow */
/**
 * Internal dependencies
 */
import {
	A11Y_HIDE_FOCUS_STYLE,
	A11Y_SHOW_FOCUS_STYLE,
} from '../constants/action-types';

/**
 * Show focus style
 */
export type A11yShowFocusStyleAction = {
	type: typeof A11Y_SHOW_FOCUS_STYLE;
	payload: true;
};

export const showAccessibleFocus = () : A11yShowFocusStyleAction => {
	return {
		type: A11Y_SHOW_FOCUS_STYLE,
		payload: true,
	};
};

/**
 * Hide focus style
 */
export type A11yHideFocusStyleAction = {
	type: typeof A11Y_HIDE_FOCUS_STYLE;
	payload: false;
};

export const hideAccessibleFocus = () : A11yHideFocusStyleAction => {
	return {
		type: A11Y_HIDE_FOCUS_STYLE,
		payload: false,
	};
};



// WEBPACK FOOTER //
// ./src/actions/a11y.js